// Services
import walkerSitterService from '@/app/services/main/walker-sitter/walker-sitter-service.js';

// Constants
import { SUCCESS_MSG } from '@/app/constants/status-constants';

// Mixins
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

// Third Party Libraries
import DatePicker from 'vue2-datepicker';
import { format } from 'date-fns';

export default {
	name: 'ScheduleComponent',
	components: { DatePicker },
	mixins: [
		GoogleAnalyticsMixins,
		dateMixins,
		toastMessageMixins,
		inputTextMixins,
		userMixins
	],
	data() {
		return {
			dateRange:'',
			selectedDays:[],
			startDate:'',
			endDate:'',
			selectAll:false,
			isAPILoading:false
		}
	},
	computed: {
		isUpdateSchedule() {
			
			const { walkerSitterDetails } = this.userDetails;

			if (walkerSitterDetails) {
				const { availableDate } = walkerSitterDetails;
				let disable = true;
				
				let dateStartAt = availableDate.dateStartAt === null ? '' : availableDate.dateStartAt;

				let dateEndAt = availableDate.dateEndAt === null ? '' : availableDate.dateEndAt;

				let daysOfTheWeek = availableDate.daysOfTheWeek === null ? '' : availableDate.daysOfTheWeek;
				
				if (this.startDate !== dateStartAt && this.startDate !=='') {
					disable = false;
				}

				if (this.endDate !== dateEndAt && this.endDate !=='') {
					disable = false;
				}

				if (this.selectedDays.length !== daysOfTheWeek.length && this.selectedDays.length !==0) {
					disable = false;
				}

				this.selectedDays.forEach(day => {
					if (!daysOfTheWeek.includes(day)) {
						disable = false;
					}
				})
				if (this.selectedDays.length === 0 || this.startDate ==='') {
					disable = true;
				}

				return disable;
			}
			return false;
		}
	},
	created() {
		this.populateData();
	},
	methods: {
		populateData() {
			const {
				walkerSitterDetails
			} = this.userDetails;

			const { dateEndAt, dateStartAt, daysOfTheWeek } = walkerSitterDetails.availableDate;
			
			if (dateEndAt) {
				this.startDate = format(new Date(dateStartAt),'yyyy-MM-dd'); 
				this.endDate = format(new Date(dateEndAt),'yyyy-MM-dd'); 
				this.dateRange = [new Date(this.startDate),new Date(this.endDate)];
			}

			if (daysOfTheWeek){
				this.selectedDays  = daysOfTheWeek;
				if (daysOfTheWeek.length === 7 ) this.selectAll = true;
			}
			
		},
		check(val) {
			if (val === 'SelectAll') {
				if (!this.selectAll) {
					this.selectedDays  = ['SUN', 'FRI', 'THU', 'SAT', 'MON', 'TUE', 'WED'];
				} else {
					this.selectedDays = [];
				}
			}else{
				if (!this.selectedDays.includes(val)) {
					this.selectedDays.push(val);
					if(this.selectedDays.length === 7) this.selectAll = true;
				} else {
					this.selectAll = false;
					this.selectedDays = this.selectedDays.filter(day => {
						return day != val;
					});
				}
			}
			
		},
		setDate() {
			if (this.dateRange[0]) {
				this.startDate = format(new Date(this.dateRange[0]),'yyyy-MM-dd');
				this.endDate = format(new Date(this.dateRange[1]),'yyyy-MM-dd');
			} else {
				this.startDate = '';
				this.endDate = '';
			}
		},
		async updateSchedule() {
			
			const availabilityDetails = {
				dateEndAt: this.endDate,
				dateStartAt: this.startDate,
				daysOfTheWeek: this.selectedDays
			}
			
			walkerSitterService.postWalkerSitterAvailability(availabilityDetails)
				.then(res => {
					this.isAPILoading = false;
						if (res.status === 204 ) {
							const { SUCCESS_UPDATE_SCHEDULE } = this.toastMessages.user();

							this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_SCHEDULE);
						} else {
							this.showCustomErrorToast(res.data.errors[0].message, null, true);
						}

						//refresh user details
						this.getUserDetailsAPI();
				});	
		},
		notBeforeToday(date) {
            return date < new Date();
        }
	},
	validations() {
		return this.validationRules;
	}
}